import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9kvpmghpes2mi34sse0';

export default function ContactSection() {
  const [statusMessage, setStatusMessage] = useState('');
  const [statusType, setStatusType] = useState<'success' | 'error' | ''>('');
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatusMessage('');
    setStatusType('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatusMessage('提交成功！感谢您的反馈');
      setStatusType('success');
      form.reset();
      setCharCount(0);
      return;
    }
    formData.delete('website_alt');

    try {
      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setStatusMessage('提交成功！感谢您的反馈');
        setStatusType('success');
        form.reset();
        setCharCount(0);
      } else {
        const msg = (parsed?.meta as Record<string, string>)?.message
          || (parsed?.meta as Record<string, string>)?.detail
          || (parsed as Record<string, string>)?.message
          || responseText
          || '提交失败，请稍后再试';
        if (typeof msg === 'string' && (msg.includes('spam') || msg.includes('form data is spam'))) {
          setStatusMessage('提交失败，请稍后再试');
        } else {
          setStatusMessage(typeof msg === 'string' ? msg : '提交失败，请稍后再试');
        }
        setStatusType('error');
      }
    } catch {
      setStatusMessage('网络错误，请检查连接后重试');
      setStatusType('error');
    }
  };

  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">联系我们</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">如有域名更新线索、网站建议或合作意向，欢迎通过下方表单与我们联系</p>
        </div>

        <div className="max-w-lg mx-auto">
          <form
            onSubmit={handleSubmit}
            data-readdy-form=""
            className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-8 space-y-5"
          >
            <div>
              <label htmlFor="contact_name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
              <input
                type="text"
                id="contact_name"
                name="name"
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors text-foreground-800"
                placeholder="请输入您的姓名"
              />
            </div>

            <div>
              <label htmlFor="contact_email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
              <input
                type="email"
                id="contact_email"
                name="email"
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors text-foreground-800"
                placeholder="请输入您的邮箱"
              />
            </div>

            <div>
              <label htmlFor="contact_message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言内容
                <span className="text-foreground-400 ml-1">({charCount}/500)</span>
              </label>
              <textarea
                id="contact_message"
                name="message"
                required
                rows={4}
                maxLength={500}
                onChange={(e) => setCharCount(e.target.value.length)}
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors text-foreground-800 resize-none"
                placeholder="请描述您的问题或建议"
              />
            </div>

            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />

            <button
              type="submit"
              className="w-full py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              提交留言
            </button>

            {statusMessage && (
              <p className={`text-sm text-center ${statusType === 'success' ? 'text-secondary-600' : 'text-accent-600'}`}>
                {statusMessage}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}